import React, { Component } from 'react';
import { Field } from 'redux-form';
import { intlShape, injectIntl, FormattedMessage} from 'react-intl';
import PropTypes from 'prop-types';
import TextField from '../../../shared-components/TextField/TextField';
import { isEmpty } from '../../../shared-components/FormElement/FormElementUtils';

const LOCALE_PREFIX = 'DE/components/IBAN/IBAN';

export const isValidIBAN = (msg) => (value) => {
    const pattern = /^[a-zA-Z]{2}[0-9]{2}[a-zA-Z0-9]{4}[0-9]{7}([a-zA-Z0-9]?){0,16}?$/;
    if (pattern.test(value)) {
        return;
    } else {
        return {
            msg,
            className: 'hasError'
        };
    }
};

export class IBAN extends Component {
    static propTypes = {
        intl: intlShape.isRequired,
        placeholder: PropTypes.string
    };

    render() {
        const { intl, placeholder } = this.props;

        const ibanPlaceHolder = placeholder ? placeholder : intl.formatMessage({id: `${LOCALE_PREFIX}.IBAN-placeholder`});
        return (
            <Field
                type="text"
                id="iban"
                name="iban"
                autoComplete="off"
                autoCorrect="off"
                autoCapitalize="off"
                arialabel={ibanPlaceHolder}
                component={TextField}
                label={ibanPlaceHolder}
                validate={[isEmpty(intl.formatMessage({id: `${LOCALE_PREFIX}.IBAN-empty`})),
                    isValidIBAN(intl.formatMessage({id: `${LOCALE_PREFIX}.IBAN-invalid`}))
                ]}
            />
        );
    }
}

export default injectIntl(IBAN);

